import { render, staticRenderFns } from "./AlbumSettingsMenuNav.vue?vue&type=template&id=56a6d3a8&"
import script from "./AlbumSettingsMenuNav.vue?vue&type=script&lang=js&"
export * from "./AlbumSettingsMenuNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports